import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router";

import App from "./app/App";

import "./styles.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <BrowserRouter>
      <IntlProvider locale="en" defaultLocale="en">
        <App />
      </IntlProvider>
    </BrowserRouter>
  </StrictMode>
);
